// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productTitle":"productTitle_gn7x9"};